module.exports = __webpack_public_path__ + "static/media/dropped.56601364.svg";